export const SITE_LIST_GRID_PAGE_SIZE = 6;
export const SITE_LIST_GRID_PAGE_SIZES = [6, 12, 24, 30];

export const SITE_LIST_PAGE_SIZE = 10;
export const SITE_LIST_PAGE_SIZES = [5, 10, 15, 25];

export const HOSTING_FETCH_LIMIT = 3;
export const HOSTING_FETCH_MAX_LIMIT = 1000;
export const DEBOUNCE_DELAY = 1000;
export const SEARCH_ITEMS_PER_PAGE = 10;
